<template>
  <div class="panel-root">
    <div class="panel-container">
      <PageHeader :title="title"  @back="$emit('back')" />

      <section class="card">
        <div class="section-title"><span class="title-bar" /><span>{{ patientSectionTitle }}</span></div>

        <div class="patient-row">
          <div class="field field-search">
            <span class="field-icon"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#999"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg></span>
            <el-input v-model="searchText" class="field-el" :placeholder="patientSearchPlaceholder" @keyup.enter.native="search" />
            <span class="field-action" @click="search"><svg viewBox="0 0 24 24" width="24" height="24" fill="none"
                stroke="#555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="7" />
                <path d="M21 21l-4.3-4.3" />
              </svg></span>
          </div>
          <button class="add-btn" @click="contactDialogVisible = true">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 5v14M5 12h14" />
            </svg>
            <span>{{ patientAddButtonText }}</span>
          </button>
        </div>

        <div v-show="searchTableVisible" class="search-wrap">
          <el-table class="search-table" :data="searchArray" :show-header="true" max-height="360" width="100%"
            @row-click="tableItemClick">
            <el-table-column min-width="150" property="name" label="姓名" />
            <el-table-column min-width="150" property="phoneNo" label="电话" />
            <el-table-column min-width="200" label="出生日期">
              <template slot-scope="scope">
                {{ scope.row.birthday }}
                <span v-if="shouldShowTime(scope.row.birthHour, scope.row.birthMinute)">{{
                  formatTimeValue(scope.row.birthHour) }}:{{ formatTimeValue(scope.row.birthMinute) }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination v-if="totalPage > 10" class="pagination" background layout="prev, pager, next"
            :current-page="currentPageNo" @current-change="pageChange" :total="totalPage" />
        </div>

        <div v-if="selectContactVisible" class="contact-card">
          <div v-if="!isEmptyValue(selectContact.name)" class="cc-row"><span class="ck">姓名</span><span class="cv">{{
              selectContact.name }}</span></div>
          <div v-if="!isEmptyValue(selectContact.sex)" class="cc-row"><span class="ck">性别</span><span class="cv">{{
            selectContact.sex == '0' ? '女' : '男' }}</span></div>
          <div v-if="!isEmptyValue(selectContact.phoneNo)" class="cc-row"><span class="ck">电话</span><span class="cv">{{
            selectContact.phoneNo }}</span></div>
          <div v-if="!isEmptyValue(selectContact.birthday)" class="cc-row"><span class="ck">出生日期</span><span
              class="cv">{{
                selectContact.birthday }}<span v-if="shouldShowTime(selectContact.birthHour, selectContact.birthMinute)">
                {{
                  formatTimeValue(selectContact.birthHour) }}:{{ formatTimeValue(selectContact.birthMinute)
                }}</span></span></div>
          <div v-if="!isEmptyValue(selectContact.liveArea)" class="cc-row"><span class="ck">常住地址</span><span
              class="cv">{{
                selectContact.liveArea }}</span></div>
          <div v-if="!isEmptyValue(selectContact.birthArea)" class="cc-row"><span class="ck">出生地址</span><span
              class="cv">{{
                selectContact.birthArea }}</span></div>
        </div>

        <div class="divider" />

        <div class="section-title"><span class="title-bar" /><span>使用信息</span></div>

        <div v-if="ganZhiRadioVisible" class="ganZhi-group">
          <el-radio-group v-model="ganZhiPrescriptionTimeType" size="large" @change="onPrescriptionTypeChange">
            <el-radio-button label="monthly">{{ monthLabel }}</el-radio-button>
            <el-radio-button label="daily">{{ dayLabel }}</el-radio-button>
            <el-radio-button label="hourly">{{ hourLabel }}</el-radio-button>
          </el-radio-group>
          <div v-if="ganZhiPrescriptionTimeType === 'monthly'" class="prescription-tip">以月/半月为周期</div>
          <div v-else-if="ganZhiPrescriptionTimeType === 'daily'" class="prescription-tip">以日为周期</div>
          <div v-else-if="ganZhiPrescriptionTimeType === 'hourly'" class="prescription-tip">以时辰为周期</div>
        </div>

        <div class="field-wrap">
          <div class="field">
            <span class="field-icon"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#888"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <path d="M16 2v4M8 2v4M3 10h18" />
              </svg></span>
            <el-date-picker class="field-el" v-model="useDate" size="large" @change="useDateChange" :editable="false"
              :picker-options="useDatePickerOptions" prefix-icon="clear" :placeholder="datePlaceholder"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" />
          </div>
        </div>

        <div v-if="illDayVisible" class="field-wrap">
          <div class="field">
            <span class="field-icon"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#888"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <path d="M16 2v4M8 2v4M3 10h18M12 14v4M10 16h4" />
              </svg></span>
            <el-date-picker class="field-el" v-model="illDay" size="large" :picker-options="illPickerOptions"
              :editable="false" prefix-icon="clear" :placeholder="illDayPlaceholder" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              type="date" />
          </div>
        </div>

        <div v-if="daysFieldVisible" class="field-wrap">
          <div class="field">
            <span class="field-icon"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#888"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="9" width="18" height="6" rx="3" />
                <path d="M9 9v6M15 9v6" />
              </svg></span>
            <el-input class="field-el" @wheel.native.prevent v-model="useDays" :placeholder="dynamicDayPlaceholder"
              type="number" />
          </div>
        </div>

        <div v-if="hourRangeVisible" class="field-wrap">
          <div class="field field-select">
            <span class="field-icon"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#888"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="9" />
                <path d="M12 7v5l3 2" />
              </svg></span>
            <el-select class="field-el" v-model="ganZhiPrescriptionHourRange" placeholder="请选择时段">
              <el-option v-for="item in timeRangeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
        </div>

        <button class="submit-btn" @click="onSubmit">{{ submitButtonText }}</button>
      </section>
    </div>

    <patient-form-dialog :visible.sync="contactDialogVisible" mode="add" :dialog-width="dialogWidth"
      :address-required="addressRequired" :add-title="patientAddDialogTitle" @success="onPatientFormSuccess"
      @success-multi="onPatientFormSuccessMulti" />
  </div>
</template>

<script>
import PageHeader from "./PageHeader.vue";
import PatientFormDialog from "./PatientFormDialog.vue";

export default {
  name: "ConsultContactPanel",
  components: { PageHeader, PatientFormDialog },
  props: {
    title: { type: String, default: "自拟组方" },
    showVerticalLabel: { type: Boolean, default: false },
    datePlaceholder: { type: String, default: "请选择开始服药日期" },
    dayPlaceholder: { type: String, default: "请输入服药天数（不大于30天）" },
    showUseDays: { type: Boolean, default: true },
    maxUseDays: { type: Number, default: 30 },
    showGanZhiControls: { type: Boolean, default: false },
    showIllDay: { type: Boolean, default: false },
    submitButtonText: { type: String, default: "开始咨询" },
    addressRequired: { type: Boolean, default: true },
    dialogWidth: { type: String, default: "600px" },
    initialContact: { type: Object, default: null },
    initialUseDate: { type: String, default: "" },
    initialUseDays: { type: String, default: "" },
    initialIllDay: { type: String, default: "" },
    initialGanZhiPrescriptionTimeType: { type: String, default: "" },
    initialGanZhiPrescriptionHourRange: { type: String, default: "" },
    futureDateMessage: { type: String, default: "开方日期必须大于当前日期" },
    patientSectionTitle: { type: String, default: "患者信息" },
    patientSearchPlaceholder: { type: String, default: "请输入患者姓名或出生日期" },
    patientAddButtonText: { type: String, default: "添加患者信息" },
    patientAddDialogTitle: { type: String, default: "" },
    illDayPlaceholder: { type: String, default: "请选择发病日期" },
    dayPlaceholderMonthly: { type: String, default: "请输入服药天数（不大于30天）" },
    dayPlaceholderDaily: { type: String, default: "请输入服药天数（不大于3天）" },
    monthLabel: { type: String, default: "月方" },
    dayLabel: { type: String, default: "日方" },
    hourLabel: { type: String, default: "时方" }
  },
  data() {
    return {
      searchText: "",
      searchArray: [],
      searchTableVisible: false,
      selectContact: {},
      selectContactVisible: false,
      contactDialogVisible: false,
      useDate: "",
      illDay: "",
      useDays: "",
      ganZhiPrescriptionTimeType: "",
      ganZhiPrescriptionHourRange: "",
      useDaysPlaceholder: this.dayPlaceholder,
      totalPage: 1,
      currentPageNo: 1,
      pageSize: 5,
      timeRangeOptions: this.buildTimeRangeOptions()
    };
  },
  computed: {
    // 药食同源调理方案流程：使用"调理人/调理方案"等文案，避免出现患者/开方/服药等字眼
    isChaoweiFlow() { return this.title === "药食同源调理方案"; },
    patientLabel() { return this.isChaoweiFlow ? "调理人" : "患者"; },
    ganZhiRadioVisible() { return this.showGanZhiControls; },
    illDayVisible() { return this.showIllDay; },
    daysFieldVisible() {
      if (!this.showUseDays) return false;
      if (this.showGanZhiControls && this.ganZhiPrescriptionTimeType === "hourly") return false;
      return true;
    },
    hourRangeVisible() { return this.showGanZhiControls && this.ganZhiPrescriptionTimeType === "hourly"; },
    effectiveMaxUseDays() {
      if (this.showGanZhiControls && this.ganZhiPrescriptionTimeType === "daily") return 3;
      return this.maxUseDays;
    },
    dynamicDayPlaceholder() {
      if (this.showGanZhiControls && this.ganZhiPrescriptionTimeType === "daily") return this.dayPlaceholderDaily;
      if (this.showGanZhiControls && this.ganZhiPrescriptionTimeType === "monthly") return this.dayPlaceholderMonthly;
      return this.useDaysPlaceholder;
    },
    illPickerOptions() {
      return { disabledDate(time) { return time.getTime() > Date.now(); } };
    },
    useDatePickerOptions() {
      return {
        disabledDate(time) {
          const now = new Date();
          const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
          const end = new Date(start);
          end.setFullYear(end.getFullYear() + 2);
          return time.getTime() < start.getTime() || time.getTime() > end.getTime();
        }
      };
    }
  },
  mounted() {
    if (this.initialContact && Object.keys(this.initialContact).length > 0) {
      this.selectContact = this.initialContact;
      this.selectContactVisible = true;
    }
    if (this.initialUseDate) this.useDate = this.initialUseDate;
    if (this.initialUseDays) this.useDays = this.initialUseDays;
    if (this.initialIllDay) this.illDay = this.initialIllDay;
    if (this.initialGanZhiPrescriptionTimeType) this.ganZhiPrescriptionTimeType = this.initialGanZhiPrescriptionTimeType;
    if (this.initialGanZhiPrescriptionHourRange) this.ganZhiPrescriptionHourRange = this.initialGanZhiPrescriptionHourRange;
  },
  methods: {
    buildTimeRangeOptions() {
      const opts = [];
      for (let h = 0; h < 23; h++) {
        const s = String(h).padStart(2, "0");
        const e = String(h + 1).padStart(2, "0");
        opts.push({ label: `${s}:00-${e}:00`, value: `${s}:00-${e}:00` });
      }
      opts.push({ label: "23:00-24:00", value: "23:00-24:00" });
      return opts;
    },
    shouldShowTime(hour, minute) { return !(this.isEmptyValue(hour) && this.isEmptyValue(minute)); },
    isEmptyValue(v) { return v === "" || v === null || v === undefined; },
    formatTimeValue(v) { if (v === "-1" || v === -1 || v === "--") return "--"; return v; },
    onPatientFormSuccess(data) {
      this.selectContact = data;
      this.searchText = "";
      this.searchArray = [];
      this.searchTableVisible = false;
      this.selectContactVisible = true;
    },
    onPatientFormSuccessMulti(data) {
      this.searchTableVisible = true;
      this.selectContactVisible = false;
      this.searchArray = data;
      this.selectContact = {};
    },
    search() {
      const loading = this.$loading({ lock: true, text: "搜索中...", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.1)" });
      this.wjtHttp.post(this, "/api/patient/v1/list", { name: this.searchText.trim(), pageNum: this.currentPageNo, pageSize: this.pageSize }, false,
        (res) => {
          const data = res.data;
          loading.close();
          if (data.code == 200) {
            this.totalPage = Math.ceil(data.total / 5) * 10;
            this.searchArray = data.rows;
            if (this.searchArray.length > 0) {
              this.searchTableVisible = true;
              this.selectContactVisible = false;
            } else {
              this.$message({ message: "未找到该" + this.patientLabel + "，请手动添加", type: "warning" });
            }
          } else {
            this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : "搜索异常，请联系管理员", type: "error" });
          }
        },
        (err) => { console.log(err); loading.close(); }
      );
    },
    useDateChange(val) {
      const flag = this.utils.afterDateFromCurrent(val);
      const twoYearsFromNow = new Date();
      twoYearsFromNow.setFullYear(twoYearsFromNow.getFullYear() + 2);
      const yearAfter = new Date(val).getTime() > twoYearsFromNow.getTime();
      setTimeout(() => {
        if (!flag) { this.useDate = ""; this.$message({ message: this.futureDateMessage, type: "warning" }); }
        if (yearAfter) { this.useDate = ""; this.$message({ message: (this.isChaoweiFlow ? "调理" : "开方") + "日期必须在两年以内", type: "warning" }); }
      }, 100);
    },
    tableItemClick(row) {
      if (!this.shouldShowTime(row.birthHour, row.birthMinute)) {
        this.$confirm("该" + this.patientLabel + "未填写出生时辰，请前往补充", "提示", { confirmButtonText: "确定", cancelButtonText: "取消" })
          .then(() => { this.$router.push({ path: "/Contact", query: { editPatientId: row.patientId } }); })
          .catch(() => { });
        return;
      }
      this.searchTableVisible = false;
      this.selectContact = row;
    },
    pageChange(pageNo) { this.currentPageNo = pageNo; this.search(); },
    onPrescriptionTypeChange(val) {
      if (val === "hourly") { this.useDays = ""; this.useDate = ""; } else { this.ganZhiPrescriptionHourRange = ""; }
    },
    onSubmit() {
      if (this.utils.isEmptyObject(this.selectContact)) { this.$message({ message: "请先添加" + this.patientLabel + "信息", type: "error" }); return; }
      if (this.useDate.length == 0) { this.$message({ message: this.isChaoweiFlow ? "请选择开始调理日期" : "请选择使用日期", type: "error" }); return; }
      if (this.ganZhiRadioVisible && this.ganZhiPrescriptionTimeType.length == 0) {
        this.$message({ message: this.isChaoweiFlow ? "请选择月方案/日方案/时方案" : "请选择月方/日方/时方", type: "error" });
        return;
      }
      if (this.ganZhiRadioVisible && this.ganZhiPrescriptionTimeType === "hourly") {
        if (this.ganZhiPrescriptionHourRange.length == 0) { this.$message({ message: this.isChaoweiFlow ? "请选择服用时段" : "请选择时段", type: "error" }); return; }
      } else if (this.daysFieldVisible) {
        if (this.useDays.length == 0) { this.$message({ message: this.isChaoweiFlow ? "请输入调理天数" : "请输入使用天数", type: "error" }); return; }
        if (isNaN(parseInt(this.useDays))) { this.$message({ message: "请输入正确的天数", type: "error" }); return; }
        if (parseInt(this.useDays) <= 0) { this.$message({ message: this.isChaoweiFlow ? "调理天数不能小于1天" : "使用天数不能小于1天", type: "error" }); return; }
        if (parseInt(this.useDays) > this.effectiveMaxUseDays) { this.$message({ message: (this.isChaoweiFlow ? "调理天数" : "使用天数") + `不能大于${this.effectiveMaxUseDays}天`, type: "error" }); return; }
      }
      if (this.illDay.length == 0) {
        const d = new Date();
        this.illDay = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
      }
      this.$emit("submit", {
        selectContact: this.selectContact,
        useDate: this.useDate,
        illDay: this.illDay,
        useDays: this.useDays,
        ganZhiPrescriptionTimeType: this.ganZhiPrescriptionTimeType,
        ganZhiPrescriptionHourRange: this.ganZhiRadioVisible && this.ganZhiPrescriptionTimeType === "hourly" ? this.ganZhiPrescriptionHourRange : ""
      });
    }
  },
  watch: {
    searchTableVisible(val) {
      if (!val && !this.utils.isEmptyObject(this.selectContact) && !this.utils.isEmptyStr(this.selectContact.name)) {
        this.selectContactVisible = true;
      }
    }
  }
};
</script>

<style scoped>
.panel-root {
  position: relative;
  min-height: 100vh;
  background: #fbfcfa;
  overflow: auto;
}

.panel-container {
  max-width: 1152px;
  margin: 0 auto;
  padding: 32px 24px 80px;
}

.card {
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid #e6e6e0;
  border-radius: 26px;
  padding: 40px;
  box-shadow: 0 18px 55px rgba(28, 55, 35, 0.12);
  backdrop-filter: blur(6px);
  width: 100%;
  max-width: 680px;
  margin: auto;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 600;
  color: #1f3327;
  margin-bottom: 26px;
}

.title-bar {
  width: 6px;
  height: 24px;
  border-radius: 4px;
  background: #20863F;
  display: inline-block;
}

.patient-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  margin-bottom: 18px;
}

.field {
  position: relative;
  display: flex;
  align-items: center;
  height: 45px;
  border: 1px solid #d9d6ce;
  border-radius: 14px;
  background: #fff;
  padding: 0 16px;
}

.field-icon {
  display: flex;
  align-items: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.field-el {
  flex: 1;
}

.field-search .field-action {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 8px;
  padding: 4px;
}

.add-btn {
  height: 43px;
  border: 2px solid #20863F;
  background: #fff;
  color: #20863F;
  border-radius: 14px;
  font-size: 17px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: background .2s;
}

.add-btn:hover {
  background: #f4f9f5;
}

.field-wrap {
  margin-bottom: 16px;
}

.field-wrap .field {
  width: 100%;
}

.search-wrap {
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 14px;
  padding: 0;
  margin-bottom: 16px;
  overflow: hidden;
}

.search-table {
  background: transparent;
  width: 100%;
}

.search-table>>>.el-table__header-wrapper {
  width: 100%;
}

.search-table>>>.el-table__header-wrapper th {
  background: #f4f9f5;
  color: #20863F;
  font-weight: 600;
  font-size: 16px;
}

.search-table>>>.el-table__row {
  font-size: 16px;
  color: #333;
  cursor: pointer;
}

.search-table>>>.el-table__row:hover td {
  background: #eef6f1 !important;
}

.search-table>>>td,
.search-table>>>th {
  padding: 14px 0;
}

.search-table>>>.el-table__body {
  width: 100% !important;
}

.search-table>>>.el-table__empty-block {
  width: 100% !important;
}

.pagination {
  margin: 0;
  padding: 14px 0;
  text-align: center;
  background: #fff;
  font-size: 18px;
}

.pagination>>>.el-pagination.is-background .el-pager li:not(.disabled).active,
.pagination>>>.el-pagination.is-background .el-pager li.active {
  background-color: #20863F !important;
  color: #fff !important;
}

.pagination>>>.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #20863F !important;
}

.pagination>>>.el-pagination.is-background .btn-next,
.pagination>>>.el-pagination.is-background .btn-prev,
.pagination>>>.el-pagination.is-background .el-pager li {
  background: #f4f9f5;
  color: #333;
  border-radius: 6px;
  font-size: 16px;
  min-width: 34px;
  height: 34px;
  line-height: 34px;
}

.pagination>>>.el-pagination.is-background .el-pager li:not(.disabled):hover,
.pagination>>>.el-pagination.is-background .el-pager li:hover {
  background: #20863F !important;
  color: #fff !important;
}

.pagination>>>.el-pagination.is-background .btn-next:not(:disabled):hover,
.pagination>>>.el-pagination.is-background .btn-prev:not(:disabled):hover {
  color: #20863F;
  background: #eaf3ee;
}

.contact-card {
  background: #f4f9f5;
  border: 1px solid #d8e6dd;
  border-radius: 14px;
  padding: 16px 22px;
  margin-bottom: 16px;
}

.cc-row {
  display: grid;
  grid-template-columns: 88px 1fr;
  font-size: 18px;
  line-height: 40px;
  color: #333;
}

.ck {
  color: #20863F;
  font-weight: 500;
}

.divider {
  height: 1px;
  background: #eee9df;
  margin: 22px 0;
}

.ganZhi-group {
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
}

.ganZhi-group>>>.el-radio-button__inner {
  padding: 12px 28px;
  font-size: 16px;
  border-radius: 30px !important;
  background: #fff;
  color: #20863F;
  border: 1px solid #20863F;
  transition: all .25s;
}

.ganZhi-group>>>.el-radio-button {
  margin-right: 10px;
}

.ganZhi-group>>>.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background: #20863F;
  color: #fff;
  border-color: #20863F;
  box-shadow: 0 4px 12px rgba(42, 122, 75, 0.3);
}

.prescription-tip {
  width: 100%;
  margin-top: 8px;
  font-size: 16px;
  color: red;
  padding-left: 4px;
}

.submit-btn {
  margin-top: 8px;
  height: 62px;
  max-width: 680px;
  width: 100%;
  border: none;
  border-radius: 14px;
  background: #20863F;
  color: #fff;
  font-size: 23px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 12px 24px rgba(42, 122, 75, 0.22);
  transition: background .2s;
}

.submit-btn:hover {
  background: #21633d;
}

/* el 组件内部去框，融入外层 field */
.field>>>.el-input__inner,
.field>>>.el-date-editor.el-input__inner,
.field>>>.el-input__inner[type="text"] {
  border: none;
  background: transparent;
  height: 45px;
  line-height: 45px;
  padding: 0;
  font-size: 17px;
  box-shadow: none;
}

.field>>>.el-input__inner::placeholder {
  color: #aaa;
}

.field>>>.el-date-editor.el-input__inner {
  width: 100%;
}

.field>>>.el-input {
  width: 100%;
}

.pagination {
  margin-top: 10px;
  text-align: center;
}

@media (min-width: 992px) {
  .patient-row {
    grid-template-columns: 1fr auto;
  }
}

@media (max-width: 768px) {
  .panel-container {
    padding: 20px 16px 60px;
  }

  .card {
    padding: 24px 18px;
    border-radius: 20px;
  }

  .submit-btn {
    font-size: 20px;
    height: 56px;
  }
}
</style>
